import React, { useEffect, useRef } from 'react';
import './zeta_DetailPanel.css';
import PanelNavbar from './PanelNavbar';
import withzeta_logo from '../assets/withzeta_logo.png';
import withzeta_panel_background from '../assets/withzeta_panel_background.png';
import withzeta_panel_center_image from '../assets/withzeta_panel_center_image.png';

const ZetaDetailPanel = ({ isOpen, onClose, sectionData }) => {
    const nextSectionRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return (
        <div className={`detail-panel-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div
                ref={contentRef}
                className={`detail-panel-content zeta-panel ${isOpen ? 'open' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <PanelNavbar onClose={onClose} variant="dark" logo={withzeta_logo} />
                <div className="panel-container">
                    <div
                        className="panel-hero-bg"
                        style={{
                            backgroundImage: `url(${withzeta_panel_background})`,
                        }}
                    ></div>
                    <div className="panel-body">
                        <h1 className="panel-main-title">AI-powered co-scientist for rare cancer research </h1>
                        <p className="panel-description-text">
                            Working on a rare cancer and struggling with fragmented, hard-to-access data? Meet withZeta — an AI research module within Lantern Labs that unifies clinical, molecular, and therapeutic information to deliver fast, evidence-grounded insights across rare and understudied cancers.
                        </p>
                        <button className="panel-try-btn" onClick={() => window.open('https://withzeta.ai', '_blank')}>
                            <span className="panel-try-btn-text">Try now</span>
                        </button>
                    </div>
                    <div className="panel-center-image-container">
                        <img
                            src={withzeta_panel_center_image}
                            alt="withZeta Analysis"
                            className="panel-center-image"
                        />
                    </div>

                    <div className="panel-next-section" ref={nextSectionRef}>
                        <div className="section-title-group">
                            <h2 className="section-title-large">Accelerate rare cancer discovery</h2>
                            <div className="accuracy-label-container">
                                <div className="accuracy-line"></div>
                                <div className="accuracy-ellipse"></div>
                                <span className="accuracy-text">with integrated intelligence</span>
                            </div>
                        </div>

                        <div className="section-description-rich">
                            <p>
                                <span className="text-italic-medium">withZeta</span>
                                <span> is Lantern Labs’ AI-driven research engine designed to streamline how teams investigate rare cancers. By connecting literature, molecular profiles, drug mechanisms, and clinical trial data, withZeta provides a unified analysis environment that dramatically reduces the time needed to uncover meaningful insights. </span>
                            </p>

                            <p className="description-spacer"></p>

                            <p>
                                <span>withZeta helps researchers identify biomarker patterns, map therapeutic opportunities, and explore mechanistic connections that are often hidden in siloed datasets. With withZeta, rare cancer discovery becomes </span>
                                <span className="text-medium">faster</span>
                                <span>, </span>
                                <span className="text-medium">clearer</span>
                                <span>, and </span>
                                <span className="text-medium">more actionable.</span>
                            </p>

                            <p className="description-spacer"></p>
                        </div>
                    </div>

                    <div className="panel-demo-section">
                        {/* Decorative Background Elements */}
                        {/* <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-1" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-2" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-3" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-4" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-5" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-6" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-7" />
                        <img src="/LanternLabs3.png" alt="" className="demo-bg-decor decor-8" /> */}

                        <div className="demo-content-wrapper">
                            <div className="demo-text-box">
                                <h2 className="demo-title">
                                    <span className="demo-title-medium">See withZeta in action </span>
                                    <span className="demo-title-light">— explore structured insights across rare cancers </span>
                                    <br />
                                </h2>
                            </div>

                            <div className="demo-symbol-container">
                                <div className="demo-vertical-line"></div>
                                <div className="demo-symbol-ellipse"></div>
                            </div>

                            <div className="demo-image-container">
                                <img
                                    src="/images/withzeta_landingpage.png"
                                    alt="withZeta Demo Interface"
                                    className="demo-ui-image"
                                />
                                <a
                                    href="https://withzeta.ai"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="demo-try-btn"
                                    style={{ textDecoration: 'none' }}
                                >
                                    <span className="demo-try-btn-text">Try now</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZetaDetailPanel;

